// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upselling-options__title[data-v-e309c1da]{font-size:16px;font-weight:400;line-height:1.2;margin:25px 0 23px;text-align:center}.upselling-options__list[data-v-e309c1da]{background-color:var(--product-select-variant-bg);margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
